import React, { useEffect, useState } from "react";
import api from '../../api/axiosInstance';
import AdminLayout from "../../components/admin/AdminLayout";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const AdminDiseases = () => {
  const [diseases, setDiseases] = useState([]);

  const loadDiseases = async () => {
    try {
      const res = await api.get("/diseases");
      setDiseases(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const deleteDisease = async (id) => {
    if (!window.confirm("Bu hastalığı silmek istediğinize emin misiniz?")) return;

    const token = localStorage.getItem("token");
    await api.delete(`/diseases/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    loadDiseases();
  };

  useEffect(() => {
    loadDiseases();
  }, []);

  return (
    <AdminLayout>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>🦠 Hastalık Yönetimi</h2>
        <Button as={Link} to="/admin/diseases/add" variant="primary">
          + Yeni Hastalık
        </Button>
      </div>

      <table className="table table-bordered table-striped mt-3">
        <thead>
          <tr>
            <th>Hastalık</th>
            <th>Açıklama</th>
            <th>Formül Sayısı</th>
            <th>İşlemler</th>
          </tr>
        </thead>

        <tbody>
          {diseases.map((d) => (
            <tr key={d._id}>
              <td>{d.name}</td>
              <td>{d.description?.slice(0, 80)}...</td>
              <td>{d.relatedFormulas?.length}</td>
              <td>
                <Button
                  as={Link}
                  to={`/admin/diseases/edit/${d._id}`}
                  size="sm"
                  variant="warning"
                  className="me-2"
                >
                  Düzenle
                </Button>

                <Button
                  size="sm"
                  variant="danger"
                  onClick={() => deleteDisease(d._id)}
                >
                  Sil
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </AdminLayout>
  );
};

export default AdminDiseases;
